import {
  GET_ALL_GG,
  GET_ALL_REQUESTOR,
  GET_ALL_USERS_BYROLE,
} from "@/api/master/user";
import querystring from "query-string";

const state = {
  listRequestor: [],
  listGG: [],
};

const mutations = {
  SET_REQUESTOR: (states, payload) => {
    states.listRequestor = payload;
  },
  SET_GG: (states, payload) => {
    states.listGG = payload;
  },
};

const actions = {
  GET_ALL_REQUESTOR: async ({ commit }, params) => {
    params = querystring.stringify(params);
    const resp = await GET_ALL_REQUESTOR(params);
    const data = resp.data.data;
    commit("SET_REQUESTOR", data);
  },
  GET_ALL_GG: async ({ commit }, params) => {
    params = querystring.stringify(params);
    const resp = await GET_ALL_GG(params);
    const data = resp.data.data;
    commit("SET_GG", data);
  },
  GET_ALL_USERS_BYROLE: async ({ commit }, params) => {
    const resp = await GET_ALL_USERS_BYROLE(params);
    const data = resp.data.data;
    return data;
  },
};

const getters = {
  requestorList: (states) => states.listRequestor,
  ggList: (states) => states.listGG,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
